import {useI18n} from 'i18n/I18nContext'
import React from 'react'
import {useFormicForm} from 'TemplateEditor/Layout/Blocks'
import {DefaultBlockConfig} from 'TemplateEditor/Layout/Blocks/DefaultBlockConfig'
import {ImageBlockConfigType} from 'TemplateEditor/Layout/Blocks/ImageBlock/ImageBlock'
import {ImageInput} from 'TemplateEditor/Layout/Blocks/ConfigInputs/ImageInput'
import {SliderInput} from 'TemplateEditor/Layout/Blocks/ConfigInputs/SliderInput'
import {DefaultBlockTopConfig} from 'TemplateEditor/Layout/Blocks/DefaultBlockTopConfig'
import {TEMPLATE_EDITOR_ACTIVE_FORM_ID} from 'TemplateEditor/templateEditorFormId'

export function ImageBlockConfig() {
  const {t} = useI18n()
  const {handleSubmit, values, setFieldValue} =
    useFormicForm<ImageBlockConfigType>()

  return (
    <>
      <form id={TEMPLATE_EDITOR_ACTIVE_FORM_ID} onSubmit={handleSubmit}>
        <DefaultBlockTopConfig values={values} setFieldValue={setFieldValue} />

        <SliderInput
          value={values.width}
          name={'width'}
          label={t('templateEditor.widthLabel')}
          setFieldValue={setFieldValue}
          max={100}
          min={0}
          step={1}
        />

        <ImageInput
          value={values.image}
          name={'image'}
          label={t('templateEditor.blockImage')}
          setFieldValue={setFieldValue}
        />

        <DefaultBlockConfig values={values} setFieldValue={setFieldValue} />
      </form>
    </>
  )
}
